
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import ResumeReportsListView from "./resume_reports-list.html";

angular.module("resume_reports", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('resume_reports', {
                url: "/resume_reports",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                data: { pageTitle: "Seguimiento" }
            })
            .state('resume_reports.list', {
                url: "/list",
                controller: "ResumeReportsCtrl",
                template: ResumeReportsListView,
                data: { pageTitle: "Seguimiento" }
            })            
        ;
    }])
;